export const Questions = [
    {
        question: 'Which of these are not known as a red wine?',
        optionA: 'Cabernet Sauvignon',
        optionB: 'Pinot Noir',
        optionC: 'Merlot',
        optionD: 'Pinot Grigio',
        answer: 'D',
    },
    {
        question: 'Which of these are not known as a white wine?',
        optionA: 'Sauvignon Blanc',
        optionB: 'Riesling',
        optionC: 'Syrah',
        optionD: 'Chardonnay',
        answer: 'C',
    },
    {
        question: 'Which is not a fortified wine?',
        optionA: 'Chardonnay',
        optionB: 'Port',
        optionC: 'Sherry',
        optionD: 'Vermouth',
        answer: 'A',
    },
    {
        question: 'If an alcoholic product is labeled at 80 proof, what is its ABV?',
        optionA: '80%',
        optionB: '40%',
        optionC: '160%',
        optionD: '20%',
        answer: 'B',
    },
    {
        question: 'Which of these isnt a cocktail?',
        optionA: 'Mai Tai',
        optionB: 'Old Fashioned',
        optionC: 'Bulleit',
        optionD: 'Mojito',
        answer: 'C',
    },
    {
        question: 'Which of these isnt a beer?',
        optionA: 'Modelo',
        optionB: 'Captain Morgan',
        optionC: 'Budweiser',
        optionD: 'Corona',
        answer: 'B',
    },
    {
        question: 'Which is a type of spiked seltzer?',
        optionA: 'White Claw',
        optionB: 'Sip of Sunshine',
        optionC: 'Natural Light',
        optionD: 'Whispering Angel',
        answer: 'A',
    },
    {
        question: 'Which is not a brand of wine?',
        optionA: 'Oyster Bay',
        optionB: 'Mezzacorona',
        optionC: 'Jack Daniels',
        optionD: 'Yellowtail',
        answer: 'C',
    },
    {
        question: 'What is the minimum legal drinking age here in CT?',
        optionA: '21',
        optionB: '18',
        optionC: '20',
        optionD: '16',
        answer: 'A',
    },
    {
        question: 'What are the 4 basic ingredients to make a beer?',
        optionA: 'Hops, Water, Molasses & Wheat',
        optionB: 'Barley, Water, Hops & Yeast',
        optionC: 'Water, Wheat, Barley & Yeast', 
        optionD: 'Water, Rice, Yeast & Rum',
        answer: 'B',
    },
    {
        question: 'How long does a tequila need to be aged to be known as an Añejo?',
        optionA: 'under 6 months',
        optionB: '9 months',
        optionC: '1-3 years', 
        optionD: 'over 5 years',
        answer: 'C',
    },
    {
        question: 'How long does a tequila need to be aged to be known as an Reposado?',
        optionA: '2-12 months',
        optionB: '1 year - 2 years',
        optionC: 'over 5 years', 
        optionD: 'over a decade',
        answer: 'A',
    },
    {
        question: 'What is not a term to associated with a 50ml alcoholic product?',
        optionA: 'A shooter',
        optionB: 'A nip',
        optionC: 'Airplane size', 
        optionD: 'A fifth',
        answer: 'D',
    },
    {
        question: 'What is considered a good wine according to the point-wine scoring-scale?',
        optionA: '95-100',
        optionB: '80-84',
        optionC: '85-89', 
        optionD: '90-94',
        answer: 'B',
    },
    {
        question: 'Which is not an S of the 5 S for wine tasting?',
        optionA: 'Swirl',
        optionB: 'Spit',
        optionC: 'Savor', 
        optionD: 'Sniff',
        answer: 'B',
    },
    {
        question: 'Which is the order in terms of dryness to sweetness in  wine?',
        optionA: 'Dry, Bone Dry, Off-dry, Very Sweet, Semi-Sweet, Sweet',
        optionB: 'Off-dry, Bone Dry, Dry, Sweet, Semi-Sweet, Very Sweet',
        optionC: 'Very Sweet, Sweet, Semi-Sweet, Off-dry, Dry, Bone Dry', 
        optionD: 'Bone Dry, Dry, Off-dry, Semi-Sweet, Sweet, Very Sweet',
        answer: 'D',
    },
    {
        question: 'How many mililiters are within a pint?',
        optionA: '200ml',
        optionB: '400ml',
        optionC: '375ml', 
        optionD: '750ml',
        answer: 'C',
    },
    {
        question: 'How many mililiters are within half a pint?',
        optionA: '200ml',
        optionB: '400ml',
        optionC: '375ml', 
        optionD: '750ml',
        answer: 'A',
    },
    {
        question: 'How many gallons does a keg contain?',
        optionA: '20',
        optionB: '15.5',
        optionC: '12.5', 
        optionD: '18.5',
        answer: 'B',
    },
    {
        question: 'Which type of wine cannot be chilled?',
        optionA: 'White Wines',
        optionB: 'Rosé',
        optionC: 'Red Wines',
        optionD: 'Sparkling Wines',
        answer: 'C'
    },
    {
        question: 'What wine does not pair well with salmon?',
        optionA: 'Cabernet Sauvignon',
        optionB: 'Chardonnay',
        optionC: 'White Burgundy',
        optionD: 'White Rioja',
        answer: 'A'
    },
    {
        question: 'What country is not considered an Old World wine',
        optionA: 'France',
        optionB: 'Spain',
        optionC: 'Poland',
        optionD: 'Australia',
        answer: 'D'
    },
    {
        question: 'Which is not a New World wine region',
        optionA: 'California',
        optionB: 'Washington',
        optionC: 'Oregon',
        optionD: 'Austria',
        answer: 'D'
    },
    {
        question: 'Which of these ingredients generally are not in the list to make a margarita?',
        optionA: 'Cointreau',
        optionB: 'Lime juice',
        optionC: 'Bitters',
        optionD: 'Tequila',
        answer: 'C'
    },
    {
        question: 'Which of these ingredients generally are not in the list to make an old fashioned?',
        optionA: 'Bourbon or Rye Whiskey',
        optionB: 'Lime juice',
        optionC: 'Bitters',
        optionD: 'Sugar Cube',
        answer: 'B'
    },
    {
        question: 'Which of these ingredients generally are not in the list to make a moscow mule?',
        optionA: 'Triple Sec',
        optionB: 'Vodka',
        optionC: 'Ginger Beer',
        optionD: 'Lime Juice',
        answer: 'A'
    },
    {
        question: 'Which of these ingredients generally are not in the list to make a mojito?',
        optionA: 'White Rum',
        optionB: 'Lime Juice',
        optionC: 'Leaves of Mints',
        optionD: 'Ginger Beer',
        answer: 'D'
    },
    {
        question: 'What not to do while opening a cork-screw type of bottled wine?',
        optionA: 'Cut the top part of the foil away',
        optionB: 'Set the screw at the center and insert it to start rotating it in',
        optionC: 'Screw it 12 half turns in',
        optionD: 'Spin until there is a single spiral loop is present',
        answer: 'C'
    },
    {
        question: 'What is not an indication if a bottle of wine has been damaged due to temperature?',
        optionA: 'The cork has started to bulge',
        optionB: 'The wine is flat, without much flavour and lacking in aroma',
        optionC: 'The coloring of the wine starts to change into a darker look',
        optionD: 'The wine will have more of a brigther look to it',
        answer: 'D'
    },
    {
        question: 'What is the recommended daily consupmtion intake of wine?',
        optionA: 'One glass of wine',
        optionB: 'Two glasses of wine',
        optionC: 'One and a half glasses of wine',
        optionD: 'Half a glass of wine',
        answer: 'A'
    }
]